import { SetStateAction } from "react";
import { ModalWithButtons } from "./modal";
import { BlackButton, GreyButton } from "../button";
import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";

interface Props {
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	setUnsavedChanges: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
}

export default function UnsavedChangesModal(props: Props) {
	const { t: translation } = useTranslation();

	const modal: React.ReactNode = (
		<ModalWithButtons
			headerText={""}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<GreyButton
					key="unsaved-changes-proceed-button"
					id="unsaved-changes-proceed-button"
					children={translation("Leavepage")}
					onClick={() => {
						props.setUnsavedChanges(false);
						setTimeout(() => props.proceedAction(), 1);
						props.setOpen(false);
					}}
				></GreyButton>,
				<BlackButton
					key="unsaved-changes-cancel-button"
					id="unsaved-changes-cancel-button"
					children={translation("Cancel")}
					onClick={() => {
						props.setOpen(false);
					}}
				></BlackButton>,
			]}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "5px",
					alignItems: "center",
					textAlign: "center",
					marginTop: "-10px",
				}}
			>
				<div className="modal-body-icon unsaved-changes-icon"></div>

				<div className="typography-body-02 typography-bold">
					{translation("UnsavedChanges")}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("UnsavedChangesMessage")}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("UnsavedChangesMessageProceed")}
				</div>
			</div>
		</ModalWithButtons>
	);

	return modal;
}
